import dayjs from 'dayjs';

const KEY_END = 35;
const KEY_HOME = 36;
const KEY_ARROW_LEFT = 37;
const KEY_ARROW_UP = 38;
const KEY_ARROW_RIGHT = 39;
const KEY_ARROW_DOWN = 40;

const useAccessible = (props, data, state, dispatch) => {
  const setUserInteraction = (value) => {
    dispatch({
      type: 'SET_USER_INTERACTION_ACTION',
      payload: value
    });
  };

  const isBlackoutDay = (day) => {
    return data.filter((item) => day.isSame(item.day, 'day'))[0]?.fareItem?.isBlackoutDay;
  };
  const isEmpty = (day) => {
    return data.filter((item) => day.isSame(item.day, 'day'))[0]?.fareItem?.dataType === 'EMPTY';
  };
  const getNextDateAfterIsEmpty = (day, direction) => {
    if (direction === 'ltr') {
      const days = data.filter(
        (item) => dayjs(item.day).isBefore(day, 'day') && item.fareItem.dataType !== 'EMPTY'
      );
      return days[days.length - 1];
    }
    return data.filter(
      (item) => dayjs(item.day).isAfter(day, 'day') && item.fareItem.dataType !== 'EMPTY'
    )[0];
  };

  const getNextDateAfterBlackoutDay = (day) => {
    return data.filter(
      (item) => dayjs(item.day).isAfter(day, 'day') && !item.fareItem.isBlackoutDay
    )[0];
  };
  const handleFocus = (e, date) => {
    if (state.focusDate === null || !dayjs(state.focusDate).isSame(date, 'day')) {
      dispatch({ type: 'SET_FOCUS_DATE', payload: date });
    }
  };

  const getNextDate = (newDate, oldDate, isEmpty = false, direction = 'rtl') => {
    let fare = getNextDateAfterBlackoutDay(newDate);
    if (isEmpty) {
      fare = getNextDateAfterIsEmpty(newDate, direction);
    }
    if (fare) {
      return dayjs(fare?.day);
    }
    return dayjs(oldDate);
  };

  const setFocusDate = (date, event) => {
    const firstDay = dayjs(state.firstDay);
    const endDay = dayjs(state.firstDay).endOf('month');
    let newDate;

    switch (event.keyCode) {
      case KEY_ARROW_RIGHT: {
        newDate = dayjs(state.focusDate).add(1, 'day');
        if (
          newDate.isBefore(endDay) &&
          newDate.isAfter(firstDay) &&
          (isBlackoutDay(newDate) || isEmpty(newDate))
        ) {
          newDate = getNextDate(newDate, state.focusDate, isEmpty(newDate));
        }

        break;
      }
      case KEY_ARROW_LEFT: {
        newDate = dayjs(state.focusDate).subtract(1, 'day');

        if (
          newDate.isBefore(endDay) &&
          newDate.isAfter(firstDay) &&
          (isBlackoutDay(newDate) || isEmpty(newDate))
        ) {
          newDate = getNextDate(newDate, state.focusDate, isEmpty(newDate), 'ltr');
        }
        break;
      }
      case KEY_ARROW_UP: {
        newDate = dayjs(state.focusDate).subtract(7, 'day');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(newDate)) {
          newDate = getNextDate(newDate, state.focusDate);
        }
        break;
      }
      case KEY_ARROW_DOWN: {
        newDate = dayjs(state.focusDate).add(7, 'day');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(newDate)) {
          newDate = getNextDate(newDate, state.focusDate);
        }
        break;
      }
      case KEY_HOME: {
        event.preventDefault();
        newDate = dayjs(date).startOf('week');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(newDate)) {
          newDate = getNextDate(newDate, state.focusDate);
        }
        break;
      }
      case KEY_END: {
        event.preventDefault();
        newDate = dayjs(date).endOf('week');
        if (newDate.isBefore(endDay) && newDate.isAfter(firstDay) && isBlackoutDay(newDate)) {
          newDate = getNextDate(newDate, state.focusDate);
        }
        break;
      }
      default: {
        return;
      }
    }
    if (
      newDate &&
      !isEmpty(newDate) &&
      (firstDay.isSame(newDate.toDate(), 'day') ||
        endDay.isSame(newDate.toDate(), 'day') ||
        (firstDay.isBefore(newDate.toDate(), 'day') && endDay.isAfter(newDate.toDate(), 'day')))
    ) {
      dispatch({ type: 'SET_FOCUS_DATE', payload: newDate.toDate() });
      setUserInteraction(true);
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  const dayCard = {
    ...props,
    focusDate: state.focusDate,
    firstDateFocusable: state.firstDateFocusable,
    setFocusDate: setFocusDate,
    onFocus: handleFocus,
    userInteraction: state.userInteraction,
    setUserInteraction: setUserInteraction
  };

  return dayCard;
};
export default useAccessible;
